var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment"},[_c('div',{staticClass:"comment__content"},[_c('p',{staticClass:"comment__date",domProps:{"textContent":_vm._s(_vm.formattedDate)}}),_c('p',{staticClass:"comment__text",domProps:{"textContent":_vm._s(_vm.text)}})]),_c('p',{staticClass:"comment__author",domProps:{"textContent":_vm._s(_vm.author.full_name)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }